import React, { useState, useEffect } from "react";
import Layout from "../../layouts";
import { toast } from "react-toastify";
import DynamicTable from "../../components/DynamicTable";
import { useLocation, useNavigate } from "react-router-dom";
import apiService from "../../services/apiService";
import { withSearchIcon } from "../../utils/helper";

export default function RefundRequests() {
  const [activeTab, setActiveTab] = useState<
    "requests" | "approved" | "rejected"
  >("approved");

  const [data, setData] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const queryEventId = new URLSearchParams(location.search).get("eventId");
  const [eventId, setEventId] = useState<any>(queryEventId);

  const pageSize = 50;
  const requestColumns = [
    { key: "id", label: "ID" },
    { key: "event_id", label: "Event ID" },
    { key: "event_name", label: withSearchIcon("Event Name") },

    {
      key: "purchase_user_id",
      label: "Purchase User Id",
      render: (v: any, row: any) => row.purchase_user_id || "—",
    },
    {
      key: "purchase_user_name",
      label: withSearchIcon("Purchase User"),
      render: (v: any, row: any) => row.purchase_user_name || "—",
    },
    {
      key: "host_user_id",
      label: "Host User Id",
      render: (v: any, row: any) => row.host_user_id || "—",
    },

    {
      key: "host_name",
      label: withSearchIcon("Host Name"),
      render: (v: any, row: any) => row.host_name || "—",
    },

    {
      key: "amount",
      label: "Amount ($)",
      render: (v: any) => `$${Number(v || 0).toFixed(2)}`,
      isDecimal: true,
    },
    // {
    //   key: "host_revenue",
    //   label: "Host Revenue ($)",
    //   render: (v: any) => `$${Number(v || 0).toFixed(2)}`,
    // },
    {
      key: "status",
      label: "Status",
      render: () => (
        <span className="px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">
          requested
        </span>
      ),
    },

    {
      key: "created_at",
      label: "Created At(Local)",
      render: (v: string) =>
        new Date(v).toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
    },
    {
      key: "updated_at",
      label: "Updated At(Local)",
      render: (v: string) =>
        new Date(v).toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
    },
  ];

  const approvedColumns = [
    { key: "id", label: "ID" },
    { key: "event_id", label: "Event ID" },
    { key: "event_name", label: withSearchIcon("Event Name") },

    {
      key: "purchase_user_id",
      label: "Purchase User Id",
      render: (v: any, row: any) => row.user_id || "—",
    },
    {
      key: "purchase_user_name",
      label: withSearchIcon("Purchase User"),
      // render: (v: any, row: any) => row.user_first_name || "—",
      render: (v: any, row: any) => {
        return `${row.user_first_name} ${row.user_last_name}` || "-";
      },
    },
    {
      key: "host_user_id",
      label: "Host User Id",
      render: (v: any, row: any) => row.host_user_id || "—",
    },

    {
      key: "host_name",
      label: withSearchIcon("Host Name"),
      render: (v: any, row: any) => {
        return `${row.host_first_name} ${row.host_last_name}` || "-";
      },
    },
    {
      key: "amount",
      label: "Amount ($)",
      render: (v: any) => `$${Number(v || 0).toFixed(2)}`,
      isDecimal: true,
    },

    {
      key: "event_refund_status",
      label: "Status",
      render: () => (
        <span className="px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
          completed
        </span>
      ),
    },

    // { key: "host_refunded_status", label: "Host Refund Status" },

    { key: "refund_id", label: "Refund ID" },

    {
      key: "created_at",
      label: "Created At(Local)",
      render: (v: string) =>
        new Date(v).toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
    },
    {
      key: "updated_at",
      label: "Updated At(Local)",
      render: (v: string) =>
        new Date(v).toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
    },
  ];

  const rejectedColumns = [
    { key: "id", label: "ID" },
    { key: "event_id", label: "Event ID" },
    { key: "event_name", label: "Event Name" },

    {
      key: "purchase_user_id",
      label: "Purchase User Id",
      render: (v: any, row: any) => row.purchase_user_id || "—",
    },
    {
      key: "purchase_user_name",
      label: "Purchase User",
      render: (v: any, row: any) => row.purchase_user_name || "—",
    },
    {
      key: "host_user_id",
      label: "Host User Id",
      render: (v: any, row: any) => row.host_user_id || "—",
    },

    {
      key: "host_name",
      label: "Host Name",
      render: (v: any, row: any) => row.host_name || "—",
    },
    {
      key: "amount",
      label: "Amount ($)",
      render: (v: any) => `$${Number(v || 0).toFixed(2)}`,
      isDecimal: true,
    },
    // {
    //   key: "host_revenue",
    //   label: "Host Revenue ($)",
    //   render: (v: any) => `$${Number(v || 0).toFixed(2)}`,
    // },

    {
      key: "status",
      label: "Status",
      render: () => (
        <span className="px-2 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
          declined
        </span>
      ),
    },

    {
      key: "reason_for_request",
      label: "Reason",
      render: (v: any) => v || "—",
    },

    {
      key: "created_at",
      label: "Created At(Local)",
      render: (v: string) =>
        new Date(v).toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
    },
    {
      key: "updated_at",
      label: "Updated At(Local)",
      render: (v: string) =>
        new Date(v).toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
    },
  ];

  // API endpoints for each tab
  const apiMap: any = {
    requests: "/event/ticket/get-ticket-refund-requests",
    approved: "/event/ticket/get-approved-ticket-refunds",
    rejected: "/event/ticket/get-declined-refund-requests",
  };

  useEffect(() => {
    fetchData(eventId, page, search);
  }, [activeTab, eventId, page, search]);

  const fetchData = async (
    eventId?: number,
    activePageNo?: number,
    searchTerm?: any
  ) => {
    try {
      setLoading(true);

      const params: any = {
        page: activePageNo,
        limit: pageSize,
        search: searchTerm,
        ...(eventId ? { eventId } : {}),
      };

      const response: any = await apiService.get(apiMap[activeTab], params);

      setData(response?.data?.data || []);
      setTotalRecords(response?.data?.totalCount || 0);
      setTotalPages(response?.data?.totalPages || 1);
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (searchKey?: any) => {
    console.log("Searching for Event ID:", searchKey);

    const params = new URLSearchParams(location.search);

    if (searchKey && searchKey.trim() !== "") {
      // ✅ Add/replace eventId
      params.set("eventId", searchKey.trim());
    } else {
      // ❌ searchKey empty → remove eventId
      params.delete("eventId");
    }

    // 🚀 Update URL (no reload)
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });

    // ✅ Update local state if needed
    setEventId(searchKey || "");
    setPage(1);
  };

  return (
    <Layout
      pageTitle="Refund Requests"
      eventId={queryEventId || eventId}
      searchByEventId={{
        label: "Search by Event ID",
        onClick: (val?: any) => handleSearch(val),
        className: "bg-green-600 hover:bg-green-700",
      }}
    >
      <div className="min-h-screen bg-gray-50 py-2 px-4">
        {/* Tabs */}
        <div className="flex gap-4 border-b mb-4">
          <button
            onClick={() => {
              setActiveTab("approved");
              setPage(1);
            }}
            className={`pb-2 px-4 ${
              activeTab === "approved"
                ? "border-b-2 border-green-600 text-green-600"
                : "text-gray-600"
            }`}
          >
            Approved
          </button>

          <button
            onClick={() => {
              setActiveTab("rejected");
              setPage(1);
            }}
            className={`pb-2 px-4 ${
              activeTab === "rejected"
                ? "border-b-2 border-red-600 text-red-600"
                : "text-gray-600"
            }`}
          >
            Rejected
          </button>
          <button
            onClick={() => {
              setActiveTab("requests");
              setPage(1);
            }}
            className={`pb-2 px-4 ${
              activeTab === "requests"
                ? "border-b-2 border-indigo-600 text-indigo-600"
                : "text-gray-600"
            }`}
          >
            Requests
          </button>
        </div>

        {/* Table */}
        <DynamicTable
          title={
            activeTab === "requests"
              ? "Refund Requests"
              : activeTab === "approved"
              ? "Approved Refunds"
              : "Rejected Refunds"
          }
          data={data}
          columns={
            activeTab === "requests"
              ? requestColumns
              : activeTab === "approved"
              ? approvedColumns
              : rejectedColumns
          }
          pageSize={pageSize}
          loading={loading}
          activeNUmber={page}
          onPageChange={(newPage) => setPage(newPage)}
          totalPages={totalPages}
          totalRecords={totalRecords}
          onSearch={(val?: any) => {
            setPage(1);
            setSearch(val);
          }}
          hasTabs={true}
        />
      </div>
    </Layout>
  );
}
